import React from 'react'

import { HeadTitle } from '@components/layout/HeadTitle'
import NoticeList from '@components/pages/important-notices/NoticeList'
import notices from '@utils/notices'

function ImportantNotices() {
  return (
    <>
      <HeadTitle
        title="Important Notices | TSA PreCheck® Enrollment Provided by CLEAR"
        description="Stay up to date with the latest notices for TSA PreCheck® Enrollment Provided by CLEAR, including ID requirements and location updates."
      />
      <div className="flex-grow max-w-4xl px-4 py-10 m-auto">
        <div className="mb-10 text-center" data-cy="important-notice-logo">
          <h1 className="text-4xl font-bold">Important Notices</h1>
        </div>
        <NoticeList notices={notices} />
      </div>
    </>
  )
}

export default ImportantNotices
